import FieldRenderer from "../global/forms/FieldRenderer";
import dataConstants from "../../constants/dataConstants";
import EditProfileFieldsProps from "../../services/models/formModels/editProfileFieldsForm.model";
import CustomTextInputProps from "../../services/models/customTextInputProps.mode";

function ForgotPasswordFields({
  touched,
  errors,
  handleChange,
  handleBlur,
  values,
  getFieldMeta
}: EditProfileFieldsProps): JSX.Element {
  return (
    <FieldRenderer
      fields={dataConstants.forgotPasswordFields.map((field, index) => ({
        key: `${index}${(field as CustomTextInputProps).labelInfo?.inputId}`,
        ...field,
        getFieldMeta,
        errors: errors,
        touched: touched,
        onChange: handleChange,
        value: values?.[!!field?.name ? field.name : ""],
        onBlur: handleBlur,
        name: field.name,
        roundedInput: true,
      }))}
    />
  );
}

export default ForgotPasswordFields;
